module.exports = "<button \n(click)=\"login()\"\nclass=\"btn btn-primary\">Login with Google</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/login/login.component.html
// module id = ./src/app/core/components/login/login.component.html
// module chunks = main